/* eslint-disable react-hooks/refs  -- TODO: fix this! (disabled initially when enabling react/hooks rules) */
import { Box, Stack, Typography } from '@mui/material';
import { useRef } from 'react';

import { TerminGenerellerKommentarCard, TerminPlanungsinformationenCard, ThemaHeader } from '../../components/general';
import { ThemaFromThemaRouter } from '../../dtos';
import { TerminAnsprechpartnerCard } from './TerminAnsprechpartnerCard';
import { TerminExpertepoolCard } from './TerminExpertepoolCard';
import { TerminPlanungsstatusCard } from './TerminPlanungsstatusCard';
import { TerminZeitlicherAblaufCard } from './TerminZeitlicherAblaufCard';
import { ThemaAusschreibungsprozessCard } from './ThemaAusschreibungsprozessCard/ThemaAusschreibungsprozessCard.tsx';
import { ThemaEigenschaftenCard } from './ThemaEigenschaftenCard';
import { ThemaTasksCard } from './ThemaTasksCard/ThemaTasksCard';
import { VeranstaltungListing } from './VeranstaltungListing';

const SCROLL_TOP_OFFSET = '200px' as const;

type ThemaProps = {
  thema: ThemaFromThemaRouter;
};

export const Thema = ({ thema }: ThemaProps) => {
  const navigation = [
    { label: 'Planung', ref: useRef<HTMLElement>(null) },
    { label: 'Veranstaltungen', ref: useRef<HTMLElement>(null) },
    { label: 'Trainer:innen', ref: useRef<HTMLElement>(null) },
    { label: 'Informationen', ref: useRef<HTMLElement>(null) },
  ];

  return (
    <Box>
      <ThemaHeader thema={thema} navigation={navigation} />

      <Stack spacing={6} sx={{ mt: 3 }}>
        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[0].ref}>
            {navigation[0].label}
          </Typography>

          <ThemaTasksCard akaProduktId={thema.akaProduktId} />

          <Stack direction="row" spacing={3} justifyContent="space-between">
            <TerminPlanungsinformationenCard thema={thema} withoutAccordion />
            <TerminPlanungsstatusCard thema={thema} />
            <TerminZeitlicherAblaufCard thema={thema} withoutAccordion />
          </Stack>

          <TerminGenerellerKommentarCard thema={thema} withoutAccordion />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[1].ref}>
            {navigation[1].label}
          </Typography>

          <VeranstaltungListing thema={thema} />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[2].ref}>
            {navigation[2].label}
          </Typography>

          <TerminExpertepoolCard thema={thema} />
        </Stack>

        <Stack spacing={3}>
          <Typography variant="headingXxs" sx={{ scrollMarginTop: SCROLL_TOP_OFFSET }} ref={navigation[3].ref}>
            {navigation[3].label}
          </Typography>

          <Stack spacing={3}>
            <TerminAnsprechpartnerCard thema={thema} />
            <ThemaEigenschaftenCard thema={thema} />
            <ThemaAusschreibungsprozessCard thema={thema} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
